import { render, staticRenderFns } from "./navbar.vue?vue&type=template&id=5f238b38&scoped=true"
import script from "./navbar.vue?vue&type=script&lang=js"
export * from "./navbar.vue?vue&type=script&lang=js"
import style0 from "./navbar.vue?vue&type=style&index=0&id=5f238b38&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.21_css-loader@6.11.0_webpack@5.101.3__lodash@4_6c7cc6d5fe7e019addcd681de453173a/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f238b38",
  null
  
)

export default component.exports